var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewAUDIO"},[(_vm.dados)?_c('div',{staticClass:"modal-conteudo m-2"},[_c('h5',{staticClass:"bold",domProps:{"innerHTML":_vm._s(_vm.dados.dsDescricao)}}),_c('audio',{staticClass:"w-100 mt-3",attrs:{"controls":"","src":_vm.dados.urlAudio}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }